/**
 * Cierra la sesión SOLO de la app (no federada con Microsoft).
 *
 * Hace POST /api/auth/logout (el cliente añade el header X-CSRF-Token), que
 * revoca la sesión en Redis, borra los tokens del usuario cacheados en la app y
 * limpia la cookie HttpOnly; devuelve { redirect } a la página de login. Después
 * navega allí. NO cierra la sesión SSO de Microsoft: volver a entrar no pedirá
 * credenciales de nuevo.
 */
import { api } from '@/api/client';

export async function logout(): Promise<void> {
  const { redirect } = await api<{ redirect: string }>('/api/auth/logout', {
    method: 'POST',
  });
  window.location.assign(redirect);
}
